import { ReactNode } from "react";

const getInfoTitleByKeyFromDataHashes = (infoData: string[], constantDataHash: Record<string, string>) => {
  return infoData.map((infoDataItem, index) => {
    if (index === 0) return constantDataHash[infoDataItem];

    return (
      (constantDataHash[infoDataItem] || '').toLowerCase()
    );
  }).filter(Boolean).join(', ');
}

type TSingleHashesValue = Record<string, Record<string, ReactNode | string>>

type TSingleHashes = {
  transportationMethod: TSingleHashesValue,
  type: TSingleHashesValue,
}

type TMultipleHashesValue = {
  icon: ReactNode;
  titles: Record<string, string>;
}

type TMultipleHashes = {
  transportationMethod: TMultipleHashesValue;
  type: TMultipleHashesValue;
}

export const getInfoBlockItem = (
  infoData: string[],
  itemType: 'transportationMethod' | 'type',
  singleHashes: TSingleHashes,
  multipleHashes: TMultipleHashes
) => {
  if (infoData?.length === 1) {
    return singleHashes[itemType][infoData[0]];
  }

  return {
    icon: multipleHashes[itemType].icon,
    title: getInfoTitleByKeyFromDataHashes(infoData, multipleHashes[itemType as string].titles)
  }
}
